import EventImage from "./EventImage";
import TextField from "./TextField";
import { Col } from "reactstrap";
import styles from "./index.module.scss";
import SelectField from "./SelectField";
import TextareaField from "./TextareaField";
import DateField from "./DateField";
import AddressForm from "./AddressForm";

interface EventImageProps {
    formState: any,
    setFormState: (prop: any) => void;
    setItemChange: (isItemChanged: boolean) => void;
}

const EventForm = ({ formState, setFormState, setItemChange }: EventImageProps) => {
    const {
        thumbnail,
        eventTitle,
        description,
        language,
        link,
        attendance,
        dtStartDate,
        dtEndDate,
        address
    } = formState;    

    const languageOptions = ["English", "Hebrew", "Arabic"];
    const AttendOptions = ["Never appears", "Always appears", "Appear only on same day based on time zone", "Appear same week", "Appear same month"];

    const updateEventImage = (value: any) => {
        setFormState({
            ...formState,
            thumbnail: value,
            hasImage: Boolean(value)
        });
        setItemChange(true);
    };

    const handleChange = (name: string, value: any) => {
        setFormState({
            ...formState,
            [name]: value
        });
        setItemChange(true);
    }
    return (
        <div>
            <EventImage
                handleChange={updateEventImage}
                fileSelected={thumbnail}
            />
            <Col md={10}>
                <TextField
                    name="eventTitle"
                    inputValue={eventTitle}
                    inputLabel="Event Name"
                    onChange={handleChange}
                    isBold
                />
            </Col>
            <Col md={10}>
                <TextareaField
                    label="Event Description"
                    value={description}
                    name="description"
                    onChange={handleChange}
                />
            </Col>
            <Col md={10} className={styles.inputContainer}>
                <SelectField
                    label="Language"
                    options={languageOptions}
                    value={language}
                    name="language"
                    onChange={handleChange}
                />
                <TextField
                    name="link"
                    inputValue={link}
                    inputType="url"
                    inputLabel="Registration URL"
                    onChange={handleChange}
                />
                <SelectField
                    label="Attendance requirement"
                    options={AttendOptions}
                    value={attendance}
                    name="attendance"
                    onChange={handleChange}
                />
            </Col>
            <Col md={10}>
                <div className={styles.sectionTitle}>Period</div>
                <div className={styles.inputContainer}>
                    <DateField
                        label="Start Date"
                        value={dtStartDate}
                        name="dtStartDate"
                        onChange={handleChange}
                    />
                    <DateField
                        label="End Date"
                        value={dtEndDate}
                        name="dtEndDate"
                        onChange={handleChange}
                    />
                </div>
            </Col>
            <Col md={10}>
                <div className={styles.sectionTitle}>Location</div>
                <AddressForm
                    address={address}
                    handleChange={handleChange}
                />
            </Col>
        </div>
    )
}

export default EventForm;